import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Container,
  Select,
  MenuItem,
  Alert,
  Typography,
  Grid,
  Paper,
  InputLabel,
  FormControl,
  Slide,
} from "@mui/material";
import LogoNutra from "../imagenes/logo_nutra.png";
import fondoLogin from "../imagenes/SILOS.jpeg"; // Asegúrate de tener esta imagen
import { useNavigate } from "react-router-dom";
import useUser from "../hooks/useUser";

//Proyecto Actualizado al : 12/03/2026


export default function Login() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState({});
  const [codigoUsuario, setCodigoUsuario] = useState("");
  const [passWord, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [tipoSelection, setTipoSelection] = useState("");
  const [area, setArea] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const user = useUser();

  user.codigo_usuario = usuario.codigo_usuario;
  user.nombre_completo = usuario.nombre_completo;
  user.id_area = usuario.id_area;
  user.estado_usuario = usuario.estado_usuario;
  user.id_usuario = usuario.id_usuario;
  user.ip = "centroformularioscixsa.com";
  
  //user.puerto = ":8080"; // Productivo  
  user.puerto = ":9090"; //QA

  const handleChangeTipo = (event) => {
    setTipoSelection(event.target.value);
  };

  const obtenerDatos = async () => {
    if (!codigoUsuario || !passWord || !tipoSelection) {
      setError("empty");
      return;
    }

    const headers = { "Content-Type": "application/json" };
    const parametros = {
      codigo_usuario: codigoUsuario,
      password: passWord,
      id_area: tipoSelection,
    };

    try {
      const url = `https://${user.ip}${user.puerto}`;
      const data = await fetch(url + "/usuario/login", {
        method: "POST",
        headers,
        body: JSON.stringify(parametros),
      });

      if (data.status !== 200) {
        setError(data.status);
      } else {


        const token = await data.json();

        //console.log(token.resultado[0].id_area);

        setUsuario({
          codigo_usuario: parametros.codigo_usuario,
          password: parametros.password,
          nombre_completo: token.resultado[0].nombre_completo,
          id_area: token.resultado[0].id_area,
          estado_usuario: token.resultado[0].estado_usuario,
          id_usuario: token.resultado[0].id_usuario,
        });


        if (token.resultado[0].id_area === 1) {

          navigate("/menu-categorias");

        }


      }
    } catch (err) {
      setError("network");
    }
  };

  const getAreas = async () => {
    try {
      const headers = { "Content-Type": "application/json" };
      const url = `https://${user.ip}${user.puerto}`;
      const data = await fetch(url + "/area/area", {
        method: "POST",
        headers,
        body: JSON.stringify({}),
      });
      const datos = await data.json();
      setArea(datos.resultado);
      setShowForm(true);
    } catch (err) {
      setError("network");
    }
  };

  useEffect(() => {
    getAreas();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${fondoLogin})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Container maxWidth="lg">
        <Slide direction="up" in={showForm} timeout={1000}>
          <Grid
            container
            spacing={4}
            alignItems="center"
            sx={{
              backdropFilter: "blur(10px)",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              borderRadius: 4,
              boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
              padding: 4,
            }}
          >
            {/* LOGO */}
            <Grid item xs={12} md={6}>
              <Box textAlign="center">
                <Typography variant="h4" gutterBottom>
                  Centro de Formularios - QA
                </Typography>
                <img
                  src={LogoNutra}
                  alt="Logo Nutra"
                  style={{
                    width: "80%",
                    maxWidth: "300px",
                    borderRadius: "12px",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Grid>

            {/* FORMULARIO */}
            <Grid item xs={12} md={6}>
              <Box>
                <Typography variant="h5" align="center" gutterBottom>
                  Bienvenido
                </Typography>
                <TextField
                  fullWidth
                  label="Código de Usuario"
                  variant="outlined"
                  margin="normal"
                  value={codigoUsuario}
                  onChange={(e) => setCodigoUsuario(e.target.value)}
                />
                <TextField
                  fullWidth
                  label="Contraseña"
                  type="password"
                  variant="outlined"
                  margin="normal"
                  value={passWord}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <FormControl fullWidth margin="normal">
                  <InputLabel>Área</InputLabel>
                  <Select
                    value={tipoSelection}
                    label="Área"
                    onChange={handleChangeTipo}
                  >
                    {area.map((row) => (
                      <MenuItem key={row.id_area} value={row.id_area}>
                        {row.desc_area}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{
                    mt: 3,
                    transition: "0.3s",
                    ":hover": {
                      backgroundColor: "#0288d1",
                    },
                  }}
                  onClick={obtenerDatos}
                >
                  Ingresar
                </Button>

                {error === "empty" && (
                  <Alert severity="warning" sx={{ mt: 2 }}>
                    Por favor complete todos los campos.
                  </Alert>
                )}
                {error === 204 && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    Usuario, contraseña o área incorrectos.
                  </Alert>
                )}
                {error === 500 && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    Error del servidor. Contacte al área de Aplicaciones.
                  </Alert>
                )}
                {error === "network" && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    Error de conexión. Verifique su red.
                  </Alert>
                )}
              </Box>
            </Grid>
          </Grid>
        </Slide>
      </Container>
    </Box>
  );
}